define('ordersDetailOrderProductOptionEditMixableOptionView',[
  'module',
  'backbone',
  'compositeView',
  'underscore',   
  'numberView',
  'ordersDetailOrderProductOptionEditMixableOptionCategoryView',
  'template!ordersDetailOrderProductOptionEditMixableOptionView'
], function (
  Module,
  Backbone,
  CompositeView,
  _,
  NumberView,
  OptionCategoryView,
  Tpl
) {
  'use strict';

  Module.exports = CompositeView.extend({
    template: Tpl,    
    childView: OptionCategoryView,
    className: 'option-view',

    childViewOptions: function () {
      return {
        product: this.options.product
      };
    },

    regions: _.extend({}, CompositeView.prototype.regions, {
      'quantity-region': '.quantity-region'
    }),

    initialize: function() {
      this.collection = new Backbone.Collection();
      _.each(this.options.product.get('productOptionCategories'), function(category) {  
        var selectedOption = null;      
        _.each(this.model.get('options'), function(option) {          
          if (option.catId === category.id)
            selectedOption = option;             
        }, this);       
        this.collection.add({
          category: category,
          option: selectedOption
        }); 
      }, this);

      CompositeView.prototype.initialize.apply(this);
    },

    serializeData: function() {
      return {
        quantity: this.model.get('quantity')
      };
    },

    onRender: function() {
      CompositeView.prototype.onRender.call(this);
      
      this.quantityView = new NumberView({});
      this.getRegion('quantity-region').show(this.quantityView);
      this.quantityView.setValue(this.model.get('quantity'));

      //---------------------------
    }
  });
});
